import { render, staticRenderFns } from "./AdviceDetails.vue?vue&type=template&id=d7179f44&scoped=true&"
import script from "./AdviceDetails.vue?vue&type=script&lang=js&"
export * from "./AdviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdviceDetails.vue?vue&type=style&index=0&id=d7179f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7179f44",
  null
  
)

export default component.exports